"use client";

import { Music, Users, Globe, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    index: "§ 02.1",
    icon: Music,
    title: "Friday Night",
    italicWord: "Socials",
    titleSuffix: "",
    description: "High-energy weekly gatherings featuring live music, team challenges, and a space for youth to connect, unwind, and build lasting friendships."
  }, {
    index: "§ 02.2",
    icon: Users,
    title: "Small Group",
    italicWord: "Discussions",
    titleSuffix: "",
    description: "Intimate, guided sessions where we dive deep into life's big questions, fostering personal growth and supportive peer mentorship."
  }, {
    index: "§ 02.3",
    icon: Globe,
    title: "Community",
    italicWord: "Projects",
    titleSuffix: "",
    description: "Hands-on volunteer initiatives that empower our members to serve the local neighborhood and create tangible, positive change together."
  }];
  return <section data-section-id="2110" id="service-projects" className="relative overflow-hidden bg-background py-28 md:py-36">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute right-[-4%] top-[2%] hidden select-none md:block" style={{
      fontFamily: "var(--font-serif)",
      fontSize: "clamp(320px, 52vw, 760px)",
      lineHeight: 0.8,
      color: "transparent",
      WebkitTextStroke: "1px hsl(226 91% 39% / 0.1)",
      opacity: 0.1,
      fontWeight: 900
    }}>
        02
      </div>
      <div aria-hidden="true" className="pointer-events-none absolute right-[-8%] top-[1%] block select-none md:hidden" style={{
      fontFamily: "var(--font-serif)",
      fontSize: "320px",
      lineHeight: 0.8,
      color: "transparent",
      WebkitTextStroke: "1px hsl(226 91% 39% / 0.1)",
      opacity: 0.1,
      fontWeight: 900
    }}>
        02
      </div>

      <div className="relative mx-auto max-w-[1440px] px-5 md:px-8 lg:px-14">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-6 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="lg:col-span-7">
            {}
            <div className="flex items-center gap-2 uppercase" style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.875rem",
            fontWeight: 500,
            letterSpacing: "0.3em",
            lineHeight: 1
          }}>
              
              
              
            </div>

            {}
            <div className="mt-5 flex items-center gap-3">
              <div className="h-px flex-1 bg-border" />
              <div className="flex items-center gap-1">
                <span className="h-1 w-1 rounded-lg bg-primary" />
                <span className="h-1 w-1 rounded-lg bg-primary" />
                <span className="h-1 w-1 rounded-lg bg-primary" />
              </div>
            </div>

            {}
            <h2 className="mt-8 font-default" style={{
            fontSize: "clamp(2rem, 5vw, 4rem)",
            fontWeight: 800,
            letterSpacing: "-0.02em",
            lineHeight: 1.0,
            color: "var(--foreground)"
          }}>
              Dynamic spaces for{" "}
              <br className="hidden sm:block" />
              every{" "}
              <em style={{
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              fontWeight: 800
            }}>
                member
              </em>
              .
            </h2>
          </div>

          <div className="lg:col-span-5 lg:flex lg:items-end">
            <p className="font-default max-w-md" style={{
            fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
            fontWeight: 400,
            lineHeight: 1.6,
            color: "var(--muted-foreground)"
          }}>
              Youth Tribe creates intentional environments where young people can explore their passions, serve their community, and find their voice through shared experiences.
            </p>
          </div>
        </div>

        {}
        <div ref={cardsRef} className="mt-20 grid grid-cols-1 gap-6 md:gap-7 lg:grid-cols-12 lg:gap-6">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} className={`lg:col-span-4 transition-all ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDuration: "720ms",
            transitionDelay: `${i * 80}ms`
          }}>
                <Card className="group relative h-full overflow-hidden p-9 transition-transform duration-300 ease-out hover:-translate-y-1" style={{
              backgroundColor: "var(--card)",
              color: "var(--card-foreground)",
              borderRadius: "0px",
              border: "1px solid var(--border)"
            }}>
                  {}
                  <span aria-hidden="true" className="pointer-events-none absolute left-3 top-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderTop: "1px solid var(--primary)",
                borderLeft: "1px solid var(--primary)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute right-3 top-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderTop: "1px solid var(--primary)",
                borderRight: "1px solid var(--primary)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-3 left-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderBottom: "1px solid var(--primary)",
                borderLeft: "1px solid var(--primary)"
              }} />
                  <span aria-hidden="true" className="pointer-events-none absolute bottom-3 right-3 h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{
                borderBottom: "1px solid var(--primary)",
                borderRight: "1px solid var(--primary)"
              }} />

                  {}
                  <div className="flex items-center gap-2 uppercase" style={{
                fontFamily: "var(--font-mono)",
                fontSize: "0.75rem",
                fontWeight: 500,
                letterSpacing: "0.3em",
                lineHeight: 1
              }}>
                    
                    
                    
                  </div>

                  {}
                  <div className="mt-8 transition-transform duration-[400ms] ease-out group-hover:rotate-6">
                    <Icon size={32} strokeWidth={1.5} className="text-primary" />
                  </div>

                  {}
                  <h3 className="mt-7 font-default" style={{
                fontSize: "clamp(1.5rem, 2.2vw, 2.25rem)",
                fontWeight: 700,
                letterSpacing: "-0.01em",
                lineHeight: 1.1,
                color: "var(--foreground)"
              }}>
                    {pillar.title}{" "}
                    <em style={{
                  fontFamily: "var(--font-serif)",
                  fontStyle: "italic",
                  fontWeight: 700
                }}>
                      {pillar.italicWord}
                    </em>
                  </h3>

                  {}
                  <p className="font-default mt-5" style={{
                fontSize: "1rem",
                fontWeight: 400,
                letterSpacing: "0",
                lineHeight: 1.5,
                color: "var(--muted-foreground)"
              }}>
                    {pillar.description}
                  </p>

                  {}
                  <div className="mt-9 flex items-center gap-3">
                    <div className="h-px flex-1 bg-border" />
                    <div className="flex items-center gap-1">
                      <span className="h-1 w-1 rounded-lg bg-primary" />
                      <span className="h-1 w-1 rounded-lg bg-primary" />
                      <span className="h-1 w-1 rounded-lg bg-primary" />
                    </div>
                  </div>

                  {}
                  <div className="mt-6">
                    <button type="button" className="group/link relative inline-flex items-center gap-2 font-default" style={{
                  fontSize: "0.9375rem",
                  fontWeight: 600,
                  color: "var(--primary)"
                }}>
                      <span className="relative">
                        Learn more
                        <span className="absolute -bottom-0.5 left-0 h-px w-0 transition-all duration-300 ease-out group-hover/link:w-full bg-primary" />
                      </span>
                      <ArrowRight size={16} strokeWidth={2} className="transition-transform duration-300 group-hover/link:translate-x-1" />
                    </button>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}